<template>
    <div class="sdk-dimension-container">
        <el-form :model="params" ref="form" :label-width="labelWidth" :rules="rules">
            <el-form-item label="个人中心页面开关：" v-if="platform !=='WINDOWS'">
                <el-checkbox :indeterminate="isIndeterminate" v-model="login_buttons_check_all" @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="params.user_center_alloweds" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="item in userCenterOptions" :label="item.key" :key="item.key" :class="{'margin_left0': true}"
                                 :disabled="item.disabled">
                        <el-tooltip
                            :content="item.content"
                            placement="top"
                            ><span>{{item.label}}</span>
                        </el-tooltip>
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>


            <el-form-item label="激励广告：" v-if="platform !== 'H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.admob_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="允许欧盟隐私弹窗:">
                <el-radio-group v-model="params.eu_consent_allowed">
                    <el-radio :label="true">允许</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>


            <el-form-item label="论坛："  v-if="platform !=='H5' && platform !='WINDOWS'">
                <el-checkbox-group v-model="params.forum_allowed">
                    <el-checkbox label="forum_allowed" :disabled="params.forum_allowed.indexOf('plug_allowed') > -1">KTPlay论坛</el-checkbox>
                    <el-checkbox label="plug_allowed" :disabled="params.forum_allowed.indexOf('forum_allowed') > -1">PLUG论坛</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="防沉迷功能："  v-if="platform !=='H5' && platform !='WINDOWS'">
                <el-radio class="anti-left" v-model="params.is_anti_addiction_turn_on" :label="true">启用</el-radio>
                <span class="anti-addiction-view" @click.stop>（<span @click.stop="handleAntiAddictionViewConfig">防沉迷规则预览</span>）</span>
                <el-tooltip
                    content="开启防沉迷功能，登录逻辑中默认关闭静默登录"
                    placement="top"
                >
                    <em class="el-icon-question"></em>
                </el-tooltip>
                <el-radio class="anti-right" v-model="params.is_anti_addiction_turn_on" :label="false">禁用</el-radio>
            </el-form-item>
            <el-form-item label="动态协议配置：">
                <el-radio v-model="params.dynamic_terms" label="" class="sdkconfigedit-ckitem-style">通用配置</el-radio>
                <div v-if="termsList" style="display: inline-block;margin-left: -4px;">
                    <el-radio class="sdkconfigedit-ckitem-style" v-for="(term,i) in termsList" :key="i" v-model="params.dynamic_terms" :label="term.id">
                        {{term.name}}
                    </el-radio>
                </div>
            </el-form-item>
            <el-form-item label="用户权限申请：" v-if="isShowImageUploadAllowed && platform !=='H5' && platform !='WINDOWS'">
                <el-checkbox v-model="params.image_upload_allowed">获取相册权限</el-checkbox>
            </el-form-item>
            <el-form-item label="AppsFlyer："  v-if="platform !=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.appsflyer_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                    label="AF等待IDFA时长："
                    v-if="
                        params.appsflyer_allowed && platform !=='H5' && platform !='WINDOWS'
                    "
                >
                <el-input-number
                    size="small"
                    v-model="params.appsflyer_wait_for_idfa_time"
                    class="sdkconfigedit-formitem-width"
                    :min="0"
                    :precision="0"
                    :controls="false"
                ></el-input-number>
                秒
            </el-form-item>
            <el-form-item label="分享功能：" v-if="platform !=='WINDOWS'">
                <el-checkbox-group v-model="params.share">
                    <el-checkbox label="fb_share_button_allowed">Facebook分享</el-checkbox>
                    <el-checkbox label="vk_share_button_allowed"  v-if="platform !=='H5'">VK分享</el-checkbox>
                    <el-checkbox label="twitter_share_button_allowed" v-if="showTwitterShare && platform !=='H5'">Twitter分享</el-checkbox>
                    <el-checkbox label="instagram_share_button_allowed"  v-if="platform !=='H5'">Instagram分享</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="Facebook分享地址："  v-if="params.share.indexOf('fb_share_button_allowed') > -1  && platform !='WINDOWS'" prop="facebook_sharing_url" key="facebook">
                <el-input
                    size="small"
                    placeholder="https://"
                    v-model="params.facebook_sharing_url"
                ></el-input>
            </el-form-item>
            <el-form-item label="VK分享地址：" v-if="params.share.indexOf('vk_share_button_allowed') > -1 && platform !=='H5' && platform !='WINDOWS'"  prop="vk_sharing_url" key="vk">
                <el-input
                    size="small"
                    placeholder="https://"
                    v-model="params.vk_sharing_url"
                ></el-input>
            </el-form-item>
            <el-form-item label="Twitter分享地址：" v-if="showTwitterShare && params.share.indexOf('twitter_share_button_allowed') > -1 && platform !=='H5' && platform !='WINDOWS'"  prop="twitter_sharing_url" key="twitter">
                <el-input
                    size="small"
                    placeholder="https://"
                    v-model="params.twitter_sharing_url"
                ></el-input>
            </el-form-item>


            <el-form-item label="网页icon：" v-if="platform==='H5' || platform ==='WINDOWS'">
                <div class="dialog-upload-btn-box">
                <div class="upload-imgs">
                    <el-form-item label-width="0">
                        <div>尺寸要求： 32*32px <font color="red">(请上传png格式)</font></div>
                        <upload size="32 * 32px" formatlimit="png"
                                v-model="params.page_icon"></upload>
                    </el-form-item>
                </div>
                </div>
            </el-form-item>

            <el-form-item label="网页背景图：" v-if="platform==='WINDOWS'">
                <div class="dialog-upload-btn-box">
                <div class="upload-imgs">
                    <el-form-item label-width="0">
                        <div>尺寸要求：宽度至少1080px,宽度可根据预期页面效果调整<font color="red">(请上传png格式)</font></div>
                        <upload  formatlimit="png" size="1920*1080px"
                                v-model="params.page_right_background_image"></upload>
                    </el-form-item>
                </div>
                </div>
            </el-form-item>

            <el-form-item label="游戏左侧背景图：" v-if="platform==='H5' && platform !='WINDOWS'">
                <div class="dialog-upload-btn-box">
                <div class="upload-imgs">
                    <el-form-item label-width="0">
                        <div>尺寸要求：宽度至少1080px,宽度可根据预期页面效果调整，<font color="red">(请上传png格式)</font></div>
                        <upload  formatlimit="png"
                                v-model="params.page_left_background_image"></upload>
                    </el-form-item>
                </div>
                </div>
            </el-form-item>

            <el-form-item label="游戏右侧背景图：" v-if="platform==='H5' && platform !='WINDOWS'">
                <div class="dialog-upload-btn-box">
                <div class="upload-imgs">
                    <el-form-item label-width="0">
                        <div>尺寸要求：宽度至少1080px,宽度可根据预期页面效果调整，与左侧背景图保持大小一致，<font color="red">(请上传png格式)</font></div>
                        <upload  formatlimit="png"
                                v-model="params.page_right_background_image"></upload>
                    </el-form-item>
                </div>
                </div>
            </el-form-item>

            <el-form-item :label="networkName" v-if="platform !=='H5' && platform !='WINDOWS'">
                <el-radio-group v-model="params.ping_stats_collection_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item
                    label="ping次数："
                    v-if="
                        params.ping_stats_collection_allowed && version < 7.10 && platform !=='H5' && platform !='WINDOWS'
                    "
                    prop="ping_count"
            >
                <el-input-number
                    size="small"
                    v-model="params.ping_count"
                    class="sdkconfigedit-formitem-width"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    ref="ping_count"
                ></el-input-number>
                次
            </el-form-item>
            <el-form-item prop="ping_domain_list"
                label="ping地址："
                v-if="
                    params.ping_stats_collection_allowed && version < 7.10 && platform !=='H5' && platform !='WINDOWS'
                ">
                <el-input
                    placeholder="建议最多填写5个，用回车分隔。"
                    size="small"
                    type="textarea"
                    v-model="params.ping_domain_list"
                    rows="4"
                    ref="ping_domain_list"
                ></el-input>
            </el-form-item>




            <el-form-item
                    prop="ping_frequency"
                    label="ping频率："
                    v-if="
                        params.ping_stats_collection_allowed && version >= 7.10 && platform !=='H5' && platform !='WINDOWS'
                    "
            >
                每
                <el-input-number
                        size="small"
                        v-model="params.ping_frequency"
                        class="ping-formitem-width"
                        :min="30"
                        :precision="0"
                        :controls="false"
                        placeholder="最少为30分钟"
                        ref="ping_frequency"
                ></el-input-number>分钟执行一次,每个域名ping

                <el-input-number
                        size="small"
                        v-model="params.ping_count"
                        class="ping-formitem-width"
                        :min="1"
                        :max="10"
                        :precision="0"
                        :controls="false"
                        placeholder="最多为10次"
                        ref="ping_count"
            ></el-input-number>
                次
          </el-form-item>

            <el-form-item
                    prop="ping_domain_list"
                    label="ping地址："
                          v-if="
                    params.ping_stats_collection_allowed && version >= 7.10 && platform !=='H5' && platform !='WINDOWS'
                ">
                <el-input
                        placeholder="注：填写URL时去掉http/https部分，支持填写IP地址"
                        size="small"
                        type="textarea"
                        v-model="params.ping_domain_list"
                        rows="4"
                        ref="ping_domain_list"
                ></el-input>
                <!--
                    我们已默认设置了对"{{ udp_domain }},https://www.facebook.com/,https://www.google.com/"的ping测试，请勿重复添加
                -->
            </el-form-item>

            <el-form-item
                    label="traceroute频率："
                    v-if="
                        params.ping_stats_collection_allowed && version >= 7.10 && platform !=='H5' && platform !='WINDOWS'
                    "
            >
                每
                <el-input-number
                        size="small"
                        v-model="params.trace_route_frequency"
                        class="ping-formitem-width"
                        :min="30"
                        :precision="0"
                        :controls="false"
                        placeholder="最少为30分钟"
                        ref="trace_route_frequency"
            ></el-input-number>
                分钟执行一次,traceroute 1次。
            </el-form-item>

            <el-form-item
                    label="traceroute地址："
                          v-if="
                    params.ping_stats_collection_allowed && version >= 7.10 && platform !=='H5' && platform !='WINDOWS'
                ">
                <el-input
                        :placeholder="tracerouteHint"
                        size="small"
                        type="textarea"
                        rows="4"
                        v-model="params.trace_route_domain_list"
                        ref="trace_route_domain_list"
                ></el-input>
                <!--
                我们已默认设置了对"{{ udp_domain }}"的traceroute测试，请勿重复添加
                -->
            </el-form-item>

            <el-form-item label="国家年龄限制："  prop="country_age_constrains_config">
                <el-input
                    size="small"
                    placeholder="例如: 'US:18,BR:17' 表示美国18岁以上，巴西17岁以上"
                    v-model="params.country_age_constrains_config"
                ></el-input>
            </el-form-item>

            <el-form-item label="PlayGameService成就:" v-if="platform === 'ANDROID'">
                <el-radio-group v-model="params.play_game_service_achievements_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="GameCenter成就:" v-if="platform === 'IOS'">
                <el-radio-group v-model="params.game_center_achievements_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="截屏分享提示："  v-if="compareVersion(version,'7.13') && platform !='WINDOWS'  && platform !='H5'">
                <el-radio-group v-model="params.screenshot_share_allowed">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="调查问卷地址：" prop="questionnaire_url" v-if="isShowQuestionnaireUrl && platform !=='H5' && platform !='WINDOWS'">
                <el-input
                    size="small"
                    v-model="params.questionnaire_url"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail">下一步</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="防沉迷规则预览" :visible.sync="antiAddictionVisible" width="650px" class="dialog-configuration">
            <configuration :go-to-configure="true"></configuration>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import upload from '../../subComponents/sdkUpload';
import configuration from "../antiAddiction/configuration";
const urlKeys = {
    fb_share_button_allowed: 'facebook_sharing_url',
    vk_share_button_allowed: 'vk_sharing_url',
    twitter_share_button_allowed: 'twitter_sharing_url'
};
export default {
    name: 'set-content-allowed',
    components: {
        configuration,
        upload
    },
    data() {
        const checkUrl = (rule, value, callback) => {
            console.log("checkurl.............", value, typeof (value));
            if (typeof (value) !== "undefined") {
                if (/^https:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/.test(value) === false) {
                    console.log("请输入正确的Url");
                    callback(new Error('请输入正确的Url'));
                }
                else {
                    callback();
                }
            }
            else {
                callback(new Error('请输入正确的Url'));
            }
        };
        return {
            login_buttons_check_all: '',
            antiAddictionVisible: false,
            isIndeterminate: false,
            operate_type: '',
            isShowQuestionnaireUrl: false,
            isShowImageUploadAllowed: true,
            isShowLoginHistoryAllowed:true,
            isVersion5x: false,
            version: '',
            udp_domain: '',
            networkName: '',
            tracerouteHint: '',
            platform:'',
            params: {
                user_center_alloweds: [],
                admob_allowed: '',
                forum_allowed: [],
                is_anti_addiction_turn_on: false,
                eu_consent_allowed: true,
                dynamic_terms: '',
                image_upload_allowed: false,
                appsflyer_allowed: true,
                appsflyer_wait_for_idfa_time: '',
                country_age_constrains_config: '',
                play_game_service_achievements_allowed: false,
                game_center_achievements_allowed: false,
                share: [],
                share_url: {},
                facebook_sharing_url: '',
                vk_sharing_url: '',
                twitter_sharing_url: '',
                ping_stats_collection_allowed: false,
                ping_count: '',
                ping_frequency: '',
                trace_route_frequency: undefined,
                trace_route_domain_list: '',
                ping_domain_list: '',
                questionnaire_url: '',
                page_icon: "",
                page_right_background_image: "",
                page_left_background_image:"",
                step: 'feature',
                screenshot_share_allowed: false
            },
            urlLoding: false,
            rules: {
                facebook_sharing_url: [{
                    required: true, validator: checkUrl
                }],
                vk_sharing_url: [{
                    required: true, validator: checkUrl
                }],
                twitter_sharing_url: [{
                    required: true, validator: checkUrl
                }],
                appsflyer_wait_for_idfa_time: [{
                    required: true, message: ' '
                }],
                ping_count: [{
                    required: true, message: ' '
                }],
                ping_domain_list: [{
                    required: true, message: ' '
                }],
                ping_frequency: [{
                    required: true, message: ' '
                }],
                trace_route_domain_list: [{
                    required: true, message: ' '
                }],
                trace_route_frequency: [{
                    required: true, message: ' '
                }],
                // questionnaire_url: [{
                //     required: true, message: ' '
                // }],
            },
            userCenterMethods: [
                {
                    label: 'OG按钮',
                    key: 'og_button_allowed',
                    content: 'OG图标的显示隐藏按钮'
                },
                {
                    label: '账号切换',
                    key: 'account_switching_allowed',
                    content: '玩家切换历史的登录账号',
                    platform: "H5"
                },

                {
                    label: '历史账号',
                    key: 'login_history_allowed',
                    content: '在同一设备下登录过的账号列表',
                    disabled: false,
                    platform: "H5"
                },
                {
                    label: '账号安全',
                    key: 'security_center_allowed',
                    content: '用于密码找回，设置安全问题的功能'
                },
                {
                    label: '问卷',
                    key: 'questionnaire',
                    content: '开启调查问卷功能'
                },
                {
                    label: '客服',
                    key: 'support_allowed',
                    content: '客服答疑开关',
                    platform: "H5"
                },
                {
                    label: 'epin兑换',
                    key: 'charge_epin_allowed',
                    content: '支付平台的渠道，类似于点卡，目前无使用',
                    marginLeft: true,
                },
                {
                    label: 'PC扫码登录',
                    key: 'qr_code_allowed',
                    content: 'SDK扫码登录，同步登录PC端登录'
                }
            ]
        };
    },
    props: ['isDetail', 'isCopy', 'labelWidth'],
    computed: {
        ...mapState(['$config', '$helper', '$lodash']),
        ...mapState("sdkReleasesEdit", [
            "gameVersion",
            "packageList",
            "packageStoreList",
            "sdkVersion",
            "termsList",
            "data"
        ]),
        userCenterOptions() {
            return this.userCenterMethods.filter((item, i) => {
                if (this.platform === "H5") {
                    return item.platform && item.platform === "H5";
                }
                else {
                    return true;
                }

            });
        }
    },
    watch: {
        'data.feature'() {
            this.params = this.$lodash.cloneDeep(this.data.feature);
            this.params.step = 'feature';
            this.handleCheckedCitiesChange(this.params.user_center_alloweds);
            this.params.ping_domain_list = typeof this.params.ping_domain_list === 'object'
                ? this.params.ping_domain_list.join(("\n"))
                                            : this.params.ping_domain_list;
            this.params.trace_route_domain_list = typeof this.params.trace_route_domain_list === 'object'
                ? this.params.trace_route_domain_list.join(("\n"))
                : this.params.trace_route_domain_list;
            /* if(!this.params.ping_domain_list) {
                this.params.ping_domain_list = this.udp_domain + "\nhttps://www.facebook.com/\nhttps://www.google.com/";
            }
            if (!this.params.trace_route_domain_list) {
                this.params.trace_route_domain_list = this.udp_domain;
            } */
            if (this.params.ping_frequency) {
                this.params.ping_frequency = parseInt(this.params.ping_frequency / 60);
            }
            if (this.params.trace_route_frequency) {
                this.params.trace_route_frequency = parseInt(this.params.trace_route_frequency / 60);
            }
            else {
                this.params.trace_route_frequency = undefined;
            }
            console.log("feature。");
            console.log(this.params);
            setTimeout(() => {
                this.params.share.forEach(item => {
                    this.$set(this.params, [urlKeys[item]], this.params.share_url[urlKeys[item]]);
                });
            }, 300);
            this.params.forum_allowed = this.data.feature.forum_allowed.length > 1 ? [] :  this.params.forum_allowed;
        },
        'data.query'(value) {
            let version = "";

            this.sdkVersion.forEach(item => {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            });
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
            console.log(this.version);
            this.networkName = this.showNetworkName();

            const versionStr = version.substr(0, 2);
            if (['6.', '5.'].includes(versionStr)) {
                this.isShowQuestionnaireUrl = true;
            }
            if (['7.', '8.'].includes(versionStr)) {
                this.isShowImageUploadAllowed = false;
                this.isShowLoginHistoryAllowed = false;
            }
            if (['5.'].includes(versionStr)) {
                this.isVersion5x = true;
            }
            this.userCenterOptions.forEach((item, i) => {
                if (this.isShowQuestionnaireUrl && item.label === '问卷') {
                    this.userCenterOptions.splice(i, 1);
                }
                if (item.label === '历史账号' && !this.isShowLoginHistoryAllowed) {
                    this.userCenterOptions[i]['disabled'] = true;
                    if (this.params.user_center_alloweds.indexOf('login_history_allowed') === -1) this.params.user_center_alloweds.push('login_history_allowed');
                }
            });
        },
    },
    methods: {
        ...mapActions("sdkReleasesEdit", [
            "GET_TERMS_LIST",
        ]),
        compareVersion(versionA, versionB) {
            if (versionA && versionB) {
                return versionA >= versionB;
            }
            else {
                return true;
            }
        },
        showNetworkName() {
            return this.version >= 7.10 ? '网络监测:' : '网络PING检测:';
        },
        showTwitterShare() {
            return this.version >= 7.12  || this.isVersion5x;
        },
        justifyVersion(version) {
            let versionarr = version.split(".");
            let version_convert = '';
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            }
            else {
                version_convert = version;
            }
            return version_convert;
        },
        handleForumAllowed(keys) {
            console.log(keys);
        },
        handleCheckAllChange(isChecked) {
            this.params.user_center_alloweds = isChecked ? this.userCenterOptions.map(item => item.key) : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(checkeds) {
            let checkedCount = checkeds.length;
            this.login_buttons_check_all = checkedCount === this.userCenterOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.userCenterOptions.length;
        },
        justifyUrl(type, onedomain) {
            let portReg = '';
            if (type == "traceroute") {
                portReg = "(:[0-9]{1,4})?";
            }
            let sRegexHead = "^((https|http|ftp|rtsp|mms)?:?/?/)";
            let sRegex =  "(^([0-9]{1,3}\.){3}[0-9]{1,3}" + // IP形式的URL- 199.194.52.184
                "|" + // 允许IP和DOMAIN（域名）
                "([0-9a-z_!~*'()-]+\.)*" + // 域名- www.
                "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." + // 二级域名
                "[a-z]{2,6})" + // first level domain- .com or .museum
                portReg + "$"; // 端口- :80
            console.log(sRegex);

            let matchUrlHead = new RegExp(sRegexHead);
            let matchUrl = new RegExp(sRegex, 'i');

            if (type == "ping") {
                if (onedomain && (!matchUrl.test(onedomain) || matchUrlHead.test(onedomain))) {
                    return false;
                }
            }
            else if (type == "traceroute") {
                if (onedomain && (!matchUrl.test(onedomain) || matchUrlHead.test(onedomain))) {
                    return false;
                }
            }
            return true;
        },
        handlerNext() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    let params = this.$lodash.cloneDeep(this.params);
                    if (this.version >= 7.10 && this.params.ping_stats_collection_allowed) {
                        if (!this.params.ping_frequency) {
                            this.$message.error("请填写ping频率！");
                            this.$refs['ping_frequency'].focus();
                            return false;
                        }
                        if (!this.params.ping_count) {
                            this.$message.error("请填写ping次数！");
                            this.$refs['ping_count'].focus();
                            return false;
                        }
                        if (!this.params.ping_domain_list) {
                            this.$message.error("请填写ping地址！");
                            this.$refs['ping_domain_list'].focus();
                            return false;
                        }
                        if (!this.params.trace_route_frequency && this.params.trace_route_domain_list) {
                            this.$message.error("请填写traceroute频率！");
                            this.$refs['trace_route_frequency'].focus();
                            return false;
                        }
                        if (this.params.trace_route_frequency && !this.params.trace_route_domain_list) {
                            this.$message.error("请填写traceroute地址！");
                            this.$refs['trace_route_domain_list'].focus();
                            return false;
                        }
                        // ping地址 正则验证
                        if (this.params.ping_domain_list) {
                            let ping_domain_array = this.params.ping_domain_list.split(("\n"));
                            console.log(ping_domain_array);
                            for (let i = 0; i < ping_domain_array.length; i++) {
                                let one_item = ping_domain_array[i];
                                let ret = this.justifyUrl("ping", one_item);
                                console.log(one_item, ret);
                                if (!ret) {
                                    this.$message({
                                        message: '请输入有效的ping地址！',
                                        type: 'error'
                                    });
                                    this.$refs['ping_domain_list'].focus();
                                    return false;
                                }
                            }
                        }
                        // traceroute 正则验证
                        if (this.params.trace_route_domain_list) {
                            let traceroute_domain_array = this.params.trace_route_domain_list.split(("\n"));
                            console.log(traceroute_domain_array);
                            for (let i = 0; i < traceroute_domain_array.length; i++) {
                                let one_item = traceroute_domain_array[i];
                                let ret = this.justifyUrl("traceroute", one_item);
                                console.log(one_item, ret);
                                if (!ret) {
                                    this.$message({
                                        message: '请输入有效的traceroute地址！',
                                        type: 'error'
                                    });
                                    this.$refs['trace_route_domain_list'].focus();
                                    return false;
                                }
                            }
                        }
                    }
                    else if (this.version < 7.10 && this.params.ping_stats_collection_allowed) {
                        if (!this.params.ping_count) {
                            this.$message.error("请填写ping次数！");
                            this.$refs['ping_count'].focus();
                            return false;
                        }
                        if (!this.params.ping_domain_list) {
                            this.$message.error("请填写ping地址！");
                            this.$refs['ping_domain_list'].focus();
                            return false;
                        }
                    }
                    params.ping_domain_list = this.params.ping_domain_list.split(("\n"));
                    params.trace_route_domain_list = this.params.trace_route_domain_list ? this.params.trace_route_domain_list.split(("\n")) : [];
                    params.share_url = {};
                    params.share.forEach(item => {
                        params.share_url[urlKeys[item]] = params[urlKeys[item]];
                    });
                    params.questionnaire_url = this.isShowQuestionnaireUrl ? params.questionnaire_url.replace(/\s*/g, '') : '';
                    if (this.isShowQuestionnaireUrl && params.questionnaire_url === '' && params.user_center_alloweds.indexOf('questionnaire') > -1)                    {
                        params.user_center_alloweds.splice(params.user_center_alloweds.indexOf('questionnaire'), 1);
                    }
                    this.$emit('submit', params);
                }
            });
        },
        handleAntiAddictionViewConfig() {
            this.antiAddictionVisible = true;
        }
    },
    created() {
        let baseurl = this.$config.apiBaseUrl.split(("/"));
        this.udp_domain =  baseurl[2];
        this.tracerouteHint = "例:\n" + this.udp_domain + "\n" + this.udp_domain + ":443\n119.75.217.109";
        this.operate_type = this.$helper.helper.getParamers("operate_type");
        this.GET_TERMS_LIST();
        this.platform = this.$helper.helper.getParamers("platform");

    }
};
</script>
<style lang="scss" scoped>
    .sdkconfigedit-formitem-width{
        width: 500px;
    }
    .ping-formitem-width{
        width: 120px;
    }
    .margin_left0{
        margin-left: 0;
    }
    .img-border{
        border: 2px dashed #C0C4CC;
        padding: 10px 20px 20px;
        display: inline-grid;
        background: #fcfcfc;
    }
    .anti-addiction-view{
        span{
            color: #5cb6ff;
            cursor: pointer;
        }
        color: #606266;
        margin-left: -153px;
        position: relative;
        z-index: 1;
    }
    .anti-left{
        margin-right: 0;
    }
    .anti-right {
        margin-left: 30px;
    }
</style>



// WEBPACK FOOTER //
// website/subComponents/sdk/SetContentAllowed.vue